import { IconName } from '@bytel/trilogy-assets/lib/iconNameEnum';

import { cmsService } from '@services/cms';

import { ProductsItem } from '@app-types/api/statics';
import { FaiTabsEnum } from '@app-types/home-fai';

import { TabConfig } from '@home-fai/components';

/**
 * Récupère les données statiques des produits FAI
 * @returns
 */
export async function faiStaticsData(): Promise<ProductsItem[]> {
    try {
        const response = await cmsService.getRocProducts();

        return response.items;
    } catch {
        return [];
    }
}

export async function getHomeFaiTabs(): Promise<{ tabs: TabConfig; defaultTab: FaiTabsEnum }> {
    try {
        const response = await cmsService.getRocTabs();

        let defaultTab: FaiTabsEnum | undefined;
        const tabs: TabConfig = {};

        response.items[0].tabs.forEach((tab, index) => {
            if (tab.default_category) {
                defaultTab = tab.slug;
            }

            tabs[tab.slug] = {
                name: tab.category,
                icon: tab.icon,
                order: index,
            };
        });

        return {
            tabs, //modif en attente de conf CE
            defaultTab: defaultTab ?? (response.items[0].tabs[0]!.category as FaiTabsEnum),
        };
    } catch {
        return {
            tabs: {
                [FaiTabsEnum.PURE_BYOU]: {
                    name: 'B&YOU Pure Fibre',
                    icon: IconName.BOX_EOLE_2,
                    order: 0,
                },
                [FaiTabsEnum.BOX_INTERNET]: {
                    name: 'Bbox',
                    icon: IconName.BOX_WIFI_6,
                    order: 1,
                },
                [FaiTabsEnum.SMART_TV_GAMING]: {
                    name: 'Bbox + TV / Gaming',
                    icon: IconName.BOX_WIFI_6_TV,
                    order: 2,
                },
                [FaiTabsEnum.BOX_5G]: {
                    name: '5G Box',
                    icon: IconName.BOX_4G,
                    order: 3,
                },
            },
            defaultTab: FaiTabsEnum.PURE_BYOU,
        };
    }
}
